export type { State } from '../Search/types';

export const resultType = {
  STATION: 'STATION',
  ARTIST: 'ARTIST',
  TRACK: 'TRACK',
  ALBUM: 'ALBUM',
  PODCAST: 'PODCAST',
  PLAYLIST: 'PLAYLIST',
  KEYWORDS: 'KEYWORDS',
} as const;

export type ResultType = (typeof resultType)[keyof typeof resultType];

export enum ContentType {
  Custom = 'custom',
  Link = 'link',
  Live = 'live',
  Playlist = 'playlist',
  Talk = 'talk',
  Track = 'track',
}

export type Result = {
  albumId?: number;
  albumName?: string;
  artistId?: number;
  artistName?: string;
  author?: string;
  callLetters?: string;
  contentId?: string;
  description: string;
  explicitLyrics?: boolean;
  id: number;
  image?: string;
  imageUrl?: string;
  name?: string;
  playbackRights?: {
    onDemand: boolean;
  };
  rank: number;
  reportingKey?: string;
  score: number;
  subtitle?: string;
  title?: string;
  typeName: ResultType;
  urls?: {
    web: string;
    image: string;
    play: string;
    goto: string;
  };
  userId?: string;
  version?: string;
  webUrl?: string;
  contentType: ContentType & string;
};

export type SearchResponse = {
  results: Array<Result>;
  bestMatch: Result;
  nextPage: string;
};
